'use strict';


const validators = {
  methods: {
    required: (v) => (!!v || v===0 || v === true || v === false) || '必填项。',
    maxLength(n) {
      return v => (!v || v.length <= n) || `长度不能超过${n}个字符。`
    },
    minLength(n) {
      return v => (!v || v.length >= n) || `长度必须大于等于${n}个字符。`
    },
    posDecimal(n = 2) {
      return v => (!v || RegExp(`^[+]?[0-9]+(\.[0-9]\{1,${n}\})?$`).test(v)) || `格式为小数点后保留${n}位的正小数。`
    },
    decimal(n = 2) {
      return v => (!v || RegExp(`^[-+]?[0-9]+(\.[0-9]\{1,${n}\})?$`).test(v)) || `格式为小数点后保留${n}位的小数。`
    },
    posInteger: v => (!v || RegExp(`^[+]?[0-9]+$`).test(v)) || `格式为正整数。`,
    integer: v => (!v || RegExp(`^[-+]?[0-9]+$`).test(v)) || `格式为整数。`,
    phoneNumber: (v) => (!v || /^1[34578]\d{9}$/.test(v) || /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(v)) || '电话号码格式不正确。',
    yearMonth: v => (!v || /^[0-9]{4}-((0[1-9])|(1[0-2]))+$/.test(v)) || `日期格式为 YYYY-MM 。`,
    date: v => (!v || /^[0-9]{4}-((0[1-9])|(1[0-2]))-((0[1-9])|([1-3][0-9]))+$/.test(v)) || `日期格式为 YYYY-MM-DD 。`,
    usciNumber: (v) => (!v || /^(([0-9A-Za-z]{15})|([0-9A-Za-z]{18})|([0-9A-Za-z]{20}))$/.test(v)) || '统一社会信用代码格式不正确。',
    greaterThan(n) {
      return v => (!v || v > n) || `${v}应该大于${n}。`
    },
    lessEquThan(n) {
      return v => (!v || Number(v) <= Number(n)) || `${v}应该小于等于${n}。`
    },
    email: (v) => (!v || /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/ig.test(v) || "邮箱地址格式不正确。" || (v && v.length < 50) ),
    equals(n) {
      return (v) => v === n
    },
    countEqual(n,msg) {
      return v => (!v || v.length === n) || ( msg || `请选择${n}项。`)
    },
  }
}

export default validators;



// WEBPACK FOOTER //
// ./src/validators/index.js